import FollowDispensaryButton from "./FollowDispensaryButton";

export default FollowDispensaryButton;
